import React from 'react';

import PipesImage from '../../../assets/pipes.png';

import { PipesCardContent, PipesCardWrapper, StyledPipes } from './styled';

const PipesCard = () => {
  return (
    <PipesCardWrapper>
      <PipesCardContent>
        <h1>Integrate and automate with ease</h1>
        <h3>
          Integrate and automate your pipeline with
          <br />
          industry-leading tools for your deployment,
          <br />
          security, and monitoring needs using Pipes.
        </h3>
        <h3>
          Get build status, context and take action with
          <br />
          your pipeline in <strong>Slack</strong> and <strong>Jira</strong>.
        </h3>
      </PipesCardContent>
      <StyledPipes src={PipesImage} alt="Pipes" />
    </PipesCardWrapper>
  );
};

export default React.memo(PipesCard);
